import type { FaireProductEntity } from "../../entity_types/product";

export const p_y4rcypyxh6: FaireProductEntity = {
  token: "p_y4rcypyxh6",
  type: "product",
  name: "Graphic CIAO Doormat-18x30\"L-3246",
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl: "https://cdn.faire.com/fastly/24fb844106ae2c8c70c9d54199d8dcdddb3acf55469b248d0d5930d119c57567.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c7b14bffb5174f3ce7f0bf703b0899b1a480ff81beeefd5befa80ebdc0c62afa.jpeg"
  ],
  priceDollars: 17.5,
  description: "Welcome your guests with a bit of stylish Italian flair with this Graphic \"CIAO\" Doormat. Crafted out of coir fiber, this naturally colored doormat features bold black lettering with a white outlook to truly make it pop. Durable coir fiber is made to withstand the worst of Canada's weather.",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:06.836Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
